module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAsElEQVQokZXSMQrCMBTG8X+l58ikt3DSxc3RQbBLlm4FRy8hODjYJbvgCZysB7HnsFQeVLA2ecZvCuH9+B4hyeb0uAFTPHHWJO/brKzlfADWQJ4K+hzwpUNHoAGWwGWkAYaoAFayjAo9aA88gW0QKqhw1rRe+AvJzADGIC+MQVlZt+lX2wyYAIsQCjXKU5+Bq4YkvUZg3K25c9bIjwqmB501c21YWzU60ljJK/2l4P4Cmx1OJglssMsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/upload/edit-ocr.png
// module id = w1tr
// module chunks = 4